export const serverUrl =
  process.env.REACT_APP_API_SERVER_URL || 'https://api.pressingapp.com'
export const clientId = '74ef73f2bc474a0cf56aabf125741332'
